import { useQuery } from "@tanstack/react-query";
import { auth, db } from "../firebase";
import { SurveyIds } from "../surveys";
import {
  collection,
  getDocs,
  query,
  Timestamp,
  where,
} from "firebase/firestore";

interface SerializedTimestamp {
  _seconds: number;
  _nanoseconds: number;
}

interface IUser {
  username: string;
  firstname: string;
  lastname: string;
  email: string;
  uuid: string;
  profilePic: string;
  bio: string;
  accountType: string;
  surveys?: Partial<Record<SurveyIds, boolean>>;
  pastTrips?: string[];
  birthDate?: Timestamp | SerializedTimestamp;
  roles?: string[];
}

/// Returns the correct Timestamp for the given one (serialized and pure objects don't share the same keys)
function ensureCorrectTimestamp(birthDate: any) {
  const seconds: number | undefined =
    birthDate["seconds"] ?? birthDate["_seconds"];

  if (!seconds) {
    return undefined;
  }

  return Timestamp.fromMillis(seconds * 1000);
}

const useCurrentUser = () => {
  return useQuery({
    queryKey: ["currentUser"],
    queryFn: async () => {
      const userId = auth.currentUser?.uid;

      if (!userId) {
        throw new Error("User not authenticated");
      }

      const userDoc = await getDocs(
        query(collection(db, "Users"), where("uuid", "==", userId))
      );

      if (userDoc.empty) {
        throw new Error("User not found");
      }

      return userDoc.docs[0].data() as IUser;
    },
  });
};

export default useCurrentUser;
export {
  type IUser as FullUser,
  type SerializedTimestamp,
  ensureCorrectTimestamp,
};
